export const types = {
  SET_INFO: "SET_INFO",
};

export const actions = {
  setInfo: (data) => {
    return {
      type: "SET_INFO",
      payLoad: data,
    };
  },
};

const initState = {
  info: [],
};

const detailsVehicleReducer = (state = initState, actions) => {
  const { type, payLoad } = actions;
  switch (type) {
    case "SET_INFO":
      return {
        ...state,
        info: payLoad,
      };
    default:
      return {
        ...state,
      };
  }
};

// const a=(state=666,actions)=>{
//   const { type, id } = actions;
//   switch (type) {
//     case "SET_USERID":
//       return {
//         ...state,
//         id:id
//       };
//     default:
//       return {
//         ...state,
//       };
//   }
// }
export default detailsVehicleReducer;
